"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.processing.done': '完成',
    'avatar.processing.is_processing': '正在处理',
};
